import Icon from './Icon';

const EmptyRadio = (props) => {
  const { color, strokeWidth = 1, ...rest } = props;
  return (
    <Icon {...rest} viewBox="0 0 24 24">
      <rect
        x="2.5"
        y="2.5"
        width="19"
        height="19"
        rx="9.5"
        fill="var(--color-base-1)"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </Icon>
  );
};

export default EmptyRadio;
